import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useSEO = ({
  title,
  description,
  keywords,
  image,
  type = 'website',
  structuredData
}) => {
  const location = useLocation();

  useEffect(() => {
    const baseUrl = window.location.origin;
    const currentUrl = `${baseUrl}${location.pathname}`;
    const ogImage = image || `${baseUrl}/logo_white_theme.png`;

    if (title) {
      document.title = title;
    }

    const updateMetaTag = (name, content, attribute = 'name') => {
      if (!content) return;
      
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    if (description) {
      updateMetaTag('description', description);
    }

    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    if (title) {
      updateMetaTag('og:title', title, 'property');
    }
    if (description) {
      updateMetaTag('og:description', description, 'property');
    }
    updateMetaTag('og:image', ogImage, 'property');
    updateMetaTag('og:url', currentUrl, 'property');
    updateMetaTag('og:type', type, 'property');
    updateMetaTag('og:site_name', 'Kigo Prints', 'property');

    if (title) {
      updateMetaTag('twitter:card', 'summary_large_image');
      updateMetaTag('twitter:title', title);
    }
    if (description) {
      updateMetaTag('twitter:description', description);
    }
    updateMetaTag('twitter:image', ogImage);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', currentUrl);

    if (structuredData) {
      let scriptTag = document.querySelector('script[type="application/ld+json"][data-seo]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.setAttribute('data-seo', 'true');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(structuredData);
    }

    return () => {
      const seoScript = document.querySelector('script[data-seo]');
      if (seoScript) {
        seoScript.remove();
      }
    };
  }, [title, description, keywords, image, type, structuredData, location.pathname]);
};

export default useSEO;

